import { useState } from 'react';
import Translate from '~/client/shared/i18n/Translate';
import Stack from '~/client/shared/Stack';
import LiveRtpTabLink from '../LiveRtpTabLink';
import LiveRtpTabs from '../LiveRtpTabs';
import TopGamesCarousel from '../TopGamesCarousel';

const TopGamesContainer: FC = () => {
  const [rtp, setRtp] = useState('highest' as RtpType);

  return (
    <Stack space="small">
      <LiveRtpTabs>
        <LiveRtpTabLink type="highest" rtp={rtp} handleClick={setRtp}>
          <Translate id="casino.highest_rtp" />
        </LiveRtpTabLink>
        <LiveRtpTabLink type="lowest" rtp={rtp} handleClick={setRtp}>
          <Translate id="casino.lowest_rtp" />
        </LiveRtpTabLink>
      </LiveRtpTabs>
      <Stack>
        <TopGamesCarousel type="highest" rtp={rtp} />
        <TopGamesCarousel type="lowest" rtp={rtp} />
      </Stack>
    </Stack>
  );
};

export default TopGamesContainer;
